"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCurrencyIcon = void 0;
const react_redux_1 = require("react-redux");
const selectors_1 = require("../containers/CommonDataProvider/selectors");
const useGetCurrencyIcon = () => {
    const currencyData = (0, react_redux_1.useSelector)(selectors_1.selectAccountCurrencyData);
    return currencyData === null || currencyData === void 0 ? void 0 : currencyData.symbol;
};
exports.useGetCurrencyIcon = useGetCurrencyIcon;
//# sourceMappingURL=useGetCurrenciesIcon.js.map